import TagManager, {TagManagerArgs} from 'react-gtm-module'

const eventQueue: Array<{event?: string}> = []
let isInitEventExisted = false
let isGTMStartExisted = false

function checkGtmAlreadyLoad() {
    if (typeof window === 'undefined') {
        return false
    }
    if (!window?.dataLayer) {
        return true
    } else {
        const dataLayer = window.dataLayer as Array<{event: string; 'gtm.start'?: number}>
        const gtmStart = dataLayer.find((item) => item.event === 'gtm.js' && item['gtm.start'])
        if (!gtmStart) {
            return true
        }
    }
    return false
}

function gtmInit() {
    try {
        if (isInitEventExisted && !isGTMStartExisted && checkGtmAlreadyLoad()) {
            const tagManagerArgs: TagManagerArgs = {
                gtmId: 'GTM-M3R7H8G',
            }
            TagManager.initialize(tagManagerArgs)
            isGTMStartExisted = true

            // Now process the queued events
            processQueue()
        }
    } catch (error) {
        console.error('Error initializing GTM:', error)
        isGTMStartExisted = false
    }
}

function pushGTMEvent(params: {event: string}) {
    setTimeout(() => {
        if (!params?.event) {
            return
        }
        const {event, ...rest} = params

        const eventValue: {event?: string} = {
            event: event,
            ...rest,
        }

        if (!isInitEventExisted && event === 'init') {
            isInitEventExisted = true
            delete eventValue.event
            // eventQueue.unshift(eventValue)
            // processQueue()
            TagManager.dataLayer({
                dataLayer: eventValue,
            })
            if (!isGTMStartExisted) gtmInit()
        } else if (event !== 'init') {
            if (!isGTMStartExisted || !isInitEventExisted) {
                eventQueue.push(eventValue)
            } else if (isGTMStartExisted && isInitEventExisted) {
                eventQueue.push(eventValue)
                processQueue()
            }
        }
    }, 0)
}

/**
 * Processes the event queue by iterating through each event and sending it to the TagManager's dataLayer.
 *
 * @function
 * @name processQueue
 *
 * @throws Will log an error to the console if processing an event fails.
 */
function processQueue() {
    while (eventQueue.length > 0) {
        const queuedEvent = eventQueue.shift()

        if (!queuedEvent) return

        try {
            TagManager.dataLayer({
                dataLayer: queuedEvent,
            })
        } catch (error) {
            console.error('Error processing queue:', error)
        }
    }
}

export {pushGTMEvent}
